<template>
  <div v-if="isAiFeatureEnabled">
    <span
      class="icon-circle mr-lg-1 mr-1 ml-1 mr-lg-0"
      @click="handleIconClick"
    >
      <img
        class="icon-nav"
        size="21"
        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiNmZmZmZmYiIHN0cm9rZS13aWR0aD0iMS43NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1zcGFya2xlcyI+PHBhdGggZD0iTTkuOTM3IDE1LjVBMiAyIDAgMCAwIDguNSAxNC4wNjNsLTYuMTM1LTEuNTgyYS41LjUgMCAwIDEgMC0uOTYyTDguNSA5LjkzNkEyIDIgMCAwIDAgOS45MzcgOC41bDEuNTgyLTYuMTM1YS41LjUgMCAwIDEgLjk2MyAwTDE0LjA2MyA4LjVBMiAyIDAgMCAwIDE1LjUgOS45MzdsNi4xMzUgMS41ODFhLjUuNSAwIDAgMSAwIC45NjRMMTUuNSAxNC4wNjNhMiAyIDAgMCAwLTEuNDM3IDEuNDM3bC0xLjU4MiA2LjEzNWEuNS41IDAgMCAxLS45NjMgMHoiLz48cGF0aCBkPSJNMjAgM3Y0Ii8+PHBhdGggZD0iTTIyIDVoLTQiLz48cGF0aCBkPSJNNCAxN3YyIi8+PHBhdGggZD0iTTUgMThIMyIvPjwvc3ZnPg=="
      >
      <span
        v-if="!aiFeatureEnabled"
        class="red-dot"
      />
    </span>

    <b-modal
      v-model="showPopup"
      :title="modalTitle"
      hide-footer
      centered
    >
      <div class="d-flex justify-content-center mb-1 mt-1">
        <span class="icon-circle-popup">
          <img
            class="icon-popup"
            size="21"
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMyMjlGRkMiIHN0cm9rZS13aWR0aD0iMS43NSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0ibHVjaWRlIGx1Y2lkZS1zcGFya2xlcyI+PHBhdGggZD0iTTkuOTM3IDE1LjVBMiAyIDAgMCAwIDguNSAxNC4wNjNsLTYuMTM1LTEuNTgyYS41LjUgMCAwIDEgMC0uOTYyTDguNSA5LjkzNkEyIDIgMCAwIDAgOS45MzcgOC41bDEuNTgyLTYuMTM1YS41LjUgMCAwIDEgLjk2MyAwTDE0LjA2MyA4LjVBMiAyIDAgMCAwIDE1LjUgOS45MzdsNi4xMzUgMS41ODFhLjUuNSAwIDAgMSAwIC45NjRMMTUuNSAxNC4wNjNhMiAyIDAgMCAwLTEuNDM3IDEuNDM3bC0xLjU4MiA2LjEzNWEuNS41IDAgMCAxLS45NjMgMHoiLz48cGF0aCBkPSJNMjAgM3Y0Ii8+PHBhdGggZD0iTTIyIDVoLTQiLz48cGF0aCBkPSJNNCAxN3YyIi8+PHBhdGggZD0iTTUgMThIMyIvPjwvc3ZnPg=="
          >
        </span>
      </div>

      <div class="text-center">
        <p class="my-2">
          Would you like to enable our new AI feature to streamline your day-to-day operations with {{ form.company_name }}?
        </p>
        <!-- Checkbox and Terms & Conditions Link -->
        <div class="d-flex justify-content-center align-items-center my-2">
          <b-form-checkbox v-model="termsAccepted">
            I have read and agree to the
            <a
              href="https://curfox.com/privacy-policy/"
              target="_blank"
            >terms & conditions</a>
          </b-form-checkbox>
        </div>
        <div class="d-flex justify-content-center mt-1 mb-1">
          <b-col class="d-flex justify-content-center">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-1"
              :disabled="!termsAccepted"
              @click="toggleFeature"
            >
              Yes
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              @click="showPopup = false"
            >
              No
            </b-button>
          </b-col>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { BModal, BButton, BFormCheckbox } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import SuccessMessage from '@core/mixins/SuccessMessage'
import ErrorMessage from '@core/mixins/ErrorMessage'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const MerchantRepository = RepositoryFactory.get('merchant')
const BusinessRepository = RepositoryFactory.get('businessSettings')
const AiSettingRepository = RepositoryFactory.get('aiSetting')
const ResourceRepository = RepositoryFactory.get('resource')

export default {
  components: {
    BModal,
    BButton,
    BFormCheckbox,
  },
  directives: {
    Ripple,
  },
  mixins: [SuccessMessage, ErrorMessage],
  data() {
    return {
      showPopup: false,
      aiFeatureEnabled: false,
      termsAccepted: false,
      form: {},
      aiSettingEnabled: false,
      availabilitySetting: '',
      aiStaffFeatureEnabled: false,
      aiModuleEnabled: false,

    }
  },
  computed: {
    modalTitle() {
      return `${this.form.company_name} AI`
    },
    isAiFeatureEnabled() {
      return ((this.aiModuleEnabled && this.aiSettingEnabled && this.availabilitySetting === 'all') || (this.aiModuleEnabled && this.aiSettingEnabled && this.availabilitySetting === 'selective' && this.aiStaffFeatureEnabled))
    },
  },
  created() {
    this.getMerchantBusinessSettingsDetails()
    this.fetchModules()
    this.readAiSetting()
  },
  mounted() {
    this.getBusinessSetting()
  },
  methods: {
    handleIconClick() {
      if (this.aiFeatureEnabled) {
        if (window.location.pathname !== '/all-orders') {
          window.location.href = 'all-orders'
        }
      } else {
        this.showPopup = true
      }
    },
    async toggleFeature() {
      this.aiFeatureEnabled = !this.aiFeatureEnabled
      await this.setMerchantSettings()
      this.showPopup = false
    },
    async getBusinessSetting() {
      try {
        const data = localStorage.getItem('businessSettings') ? JSON.parse(localStorage.getItem('businessSettings')) : (await BusinessRepository.getBusinessSettigs()).data.data
        if (!localStorage.getItem('businessSettings')) localStorage.setItem('businessSettings', JSON.stringify(data))
        this.form = data
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async getMerchantBusinessSettingsDetails() {
      try {
        if (this.$store.getters.isLoggedIn) {
          const data = localStorage.getItem('merchant_business_setting') ? JSON.parse(localStorage.getItem('merchant_business_setting')) : (await MerchantRepository.getMerchantBusinessSettingsDetails()).data.data
          if (!localStorage.getItem('merchant_business_setting')) localStorage.setItem('merchant_business_setting', JSON.stringify(data))
          this.aiFeatureEnabled = data.is_ai_active
          this.aiStaffFeatureEnabled = data.is_ai_active_staff
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async fetchModules() {
      try {
        this.loading = true
        if (this.$store.getters.isLoggedIn) {
          const data = localStorage.getItem('module_data') ? JSON.parse(localStorage.getItem('module_data')) : (await ResourceRepository.getModules()).data.data
          if (!localStorage.getItem('module_data')) localStorage.setItem('module_data', JSON.stringify(data))
          const aiSettingModule = data.find(module => module.name === 'AI Setting')
          this.aiModuleEnabled = aiSettingModule ? aiSettingModule.is_active : false
        }
      } catch (e) {
        // this.convertAndNotifyError(e)
      }
      this.loading = false
    },
    async readAiSetting() {
      try {
        if (this.$store.getters.isLoggedIn) {
          const data = localStorage.getItem('ai_setting') ? JSON.parse(localStorage.getItem('ai_setting')) : (await AiSettingRepository.getAiSetting()).data.data
          if (!localStorage.getItem('ai_setting')) localStorage.setItem('ai_setting', JSON.stringify(data))
          this.aiSettingEnabled = data.enabled
          this.availabilitySetting = data.availability_setting.preference
        }
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async setMerchantSettings() {
      const setting = {
        is_ai_active: this.aiFeatureEnabled,
      }
      try {
        const res = await BusinessRepository.getAISettigs(setting)
        if (res.status === 200) {
          this.showSuccessMessage('Successfully Updated')
          localStorage.removeItem('merchant_business_setting')
          window.location.reload()
        } else {
          this.showErrorMessage('Cannot Update Settings')
        }
      } catch (e) {
        this.showErrorMessage('Something went wrong')
      }
    },
  },
}
</script>

<style>
.icon-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: linear-gradient(220deg, #0CF0FF 10.69%, #075C99 87.24%);
  cursor: pointer;
  position: relative;
  margin-left: 5px;
  margin-right: 5px;
}
.icon-nav {
  width: 20px;
  height: 20px;
}
.red-dot {
  position: absolute;
  top: 0px;
  right: 0px;
  width: 8px;
  height: 8px;
  background-color: red;
  border-radius: 50%;
}

.icon-circle-popup {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 129px;
  height: 129px;
  border-radius: 50%;
  background-color: #CAE7FE;
  cursor: pointer;
}

.icon {
  color: white;
  transition: color 0.3s;
}

.icon-popup {
  color: #229FFC;
  width: 70px;
  height: 70px;
}

.icon-circle:hover .icon {
  color: white;
}

.text-center p,
.text-center .d-flex {
  justify-content: center;
  text-align: center;
}
@media (max-width: 768px) {
  .icon-circle {
    width: 20px;
    height: 20px;
    margin: 5px 2px
  }

  .icon-circle img {
    width: 12px;
    height: 12px;
  }
  .red-dot {
    width: 5px;
    height: 5px;
  }
}
</style>
